import React, {createContext, useContext} from 'react';

/**
 * Optional header rendered at the top of the plate map display-layer sidebar.
 * Passed via context rather than prop-drilled through the generic `PlateMapSummary`
 * and `PlateMapSidebar` components. Used by the scratch-plate design summary's
 * Design/Plates view toggle.
 */
const PlateMapSidebarHeaderContext = createContext<React.ReactNode>(null);

export const PlateMapSidebarHeaderProvider = PlateMapSidebarHeaderContext.Provider;

export function usePlateMapSidebarHeader(): React.ReactNode {
  return useContext(PlateMapSidebarHeaderContext);
}
